import { Component, input } from '@angular/core';
import { SizeFormatService } from '@shared/utils/size-format.service';
import { toSize } from '@shared/utils/size';
import { BANDWIDTH_UNIT } from '@shared/services/contract.service';
import { Contract } from '../../../theme/my-organization/my-contracts/my-contracts.component';
import { BadgeOrganizationComponent } from '../badge-organization/badge-organization.component';
import { DateFormatPipe, TranslateLabelPipe } from '../../pipe/filter.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-my-contracts-header',
  templateUrl: './my-contracts-header.component.html',
  styleUrl: './my-contracts-header.component.scss',
  imports: [BadgeOrganizationComponent, DateFormatPipe, TranslatePipe, TranslateLabelPipe],
})
export class MyContractsHeaderComponent {
  constructor(private formatSizeService: SizeFormatService) {}

  protected contract = input.required<Contract>();

  public formatSize = (value: number) => {
    return this.formatSizeService.formatSize(toSize(value));
  };
  protected readonly BANDWIDTH_UNIT = BANDWIDTH_UNIT;
}
